import React from 'react';

import TelegramIcon from '@mui/icons-material/Telegram';
import TwitterIcon from '@mui/icons-material/Twitter';
import { IconButton, Tooltip, Typography, Grid, Stack, Link } from '@mui/material';
import { useNavigate } from 'react-router';

import logo from '../images/logo.png';

import './styles.scss';
import { ABOUT_US, TELEGRAM_URL, TWITTER_URL } from './constants';
import { useStyles } from './styled';

export const Footer = () => {
  const styles = useStyles();
  const navigate = useNavigate();

  return (
    <Grid
      container
      className={styles.footerContainer}
      sx={{
        p: { md: 2, sm: 1, xs: 1 }
      }}>
      <Grid
        item
        xs={12}
        md={3}
        sx={{
          display: 'flex'
        }}>
        <Stack alignItems="center" display="flex">
          <img src={logo} height="50px" className="logo" />

          <Typography
            className={styles.styledText}
            variant="title3"
            noWrap
            onClick={() => navigate('/disclaimer')}
            component={Link}
            sx={{
              display: { xs: 'block', sm: 'block' },
              color: 'white'
            }}>
            Disclaimer
          </Typography>
        </Stack>
      </Grid>
      <Grid
        item
        xs={12}
        md={4}
        sx={{ justifyContent: 'center', alignItems: 'center', display: 'flex' }}>
        <Stack>
          <Typography
            variant="h6"
            noWrap
            component="div"
            textAlign="center"
            sx={{
              flexGrow: 1,
              display: { xs: 'block', sm: 'block' },
              color: 'white'
            }}>
            About Us
          </Typography>
          <Typography
            variant="body2"
            component="div"
            sx={{
              flexGrow: 1,
              display: { xs: 'block', sm: 'block' },
              color: 'white'
            }}
            textAlign="center">
            {ABOUT_US}
          </Typography>
        </Stack>{' '}
      </Grid>

      <Grid
        item
        xs={12}
        md={5}
        sx={{ justifyContent: 'center', alignItems: 'center', display: 'flex' }}>
        <Stack>
          <Typography
            variant="h6"
            noWrap
            component="div"
            sx={{
              display: { xs: 'block', sm: 'block' },
              color: 'white'
            }}>
            Social Links
          </Typography>
          <Stack direction="row" alignItems="center">
            <Tooltip title="Twitter">
              <IconButton
                size="large"
                edge="start"
                color="inherit"
                href={TWITTER_URL}
                target="_blank">
                <TwitterIcon sx={{ fontSize: 40, color: '#c1bfbf' }} />
              </IconButton>
            </Tooltip>
            <Tooltip title="Telegram">
              <IconButton
                size="large"
                edge="start"
                color="inherit"
                href={TELEGRAM_URL}
                target="_blank">
                <TelegramIcon sx={{ fontSize: 40, color: '#c1bfbf' }} />
              </IconButton>
            </Tooltip>
          </Stack>
        </Stack>
      </Grid>
    </Grid>
  );
};
